import React, { useContext } from "react";
import "./topNav.scss";
import { Link, useNavigate } from "react-router-dom";
import { FaBell } from "react-icons/fa6";
import { FaCircleUser } from "react-icons/fa6";
import { AuthContext } from "../../context/AuthContext";

const TopNav = () => {
  const { admin } = useContext(AuthContext);

  return (
    <div className="topNav_wrp ">
      <div className="topNav_in">
        <div></div>
        <div className="tp_l">
          <span>
            Welcome back, <em>{admin.fullName} !</em>
          </span>
          <small>Manage your platform and monitor activity at a glance</small>
        </div>
        {/* <div className="tp_r">
          <span>
            <FaCircleUser color="#2f2f2fff" size={25} />
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default TopNav;
